import React, { Component } from 'react';
import { connect } from 'react-redux';

import styles from './Machine.scss';
import { PageTitle, DonutChart, BoxTitle, Text, Button, Spacer, Icon } from 'components';
import { Link } from 'react-router-dom';
import { getTranslate } from "react-localize-redux";


class Machine extends Component {
  render() {
    let classNames = styles.machine;
    if(this.props.theme == 'light'){
      classNames = classNames + ' ' + styles.isLight
    }

    if(this.props.type=='addnew'){

      return (
        <div className={classNames}>
            <Spacer height="30px" />
            <Button  data-cy="new-machine-btn" value={this.props.translate('machinespage.new.label')} href="/machines/new"></Button>
        </div>
      )
    }else{

      return (
        <Link className={styles.machineLink} to={'/machines/'+this.props.machine.id }>
          <div className={this.props.machine.incomplete ? [ classNames, styles.batch ].join(' ') : classNames}>
                <BoxTitle ellipsis="140px" type="nopadding">{this.props.machine.name}</BoxTitle>
                <Text fontCut="light" color="#2F2D2F">{this.props.machine.heads} {this.props.machine.heads > 1 ? this.props.translate('global.machine.head.multiple') : this.props.translate('global.machine.head.one')}</Text>
                <Spacer height="12px" />
                <DonutChart 
                    size="115" 
                    align="center" 
                    fontSizeL="30px" 
                    fontSizeS="10px" 
                    value={this.props.machine.avg_efficiency} 
                    valuelabel={this.props.translate('global.machine.avg_efficiency')} 
                    value0label={this.props.translate('global.machine.not_used')} 
                    strokewidth="12"  />
                <div className={styles.delete} onClick={this.props.onDeleteHandler}><Icon type="image" size="23px" content="delete" /></div>
          </div>
        </Link>
      )
    }
  }
}

const mapStateToProps = state => {
    return {
        translate: getTranslate(state.locale)
    };
};
export default connect(mapStateToProps)(Machine);



// WEBPACK FOOTER //
// ./src/components/organisms/Machine/index.js